import RangeBar from "./RangeBar";
import { money } from "./format";

// Compact revealed AVM result for the ACCOUNT DASHBOARD card (template_key
// "account"). The dashboard's home-value card is narrow, so instead of cramming
// the full report hero + comps + agent rail into it (which overflowed — the card
// isn't the full-width report page), we surface just the headline: estimated
// value, confidence, price range, and a link out to the full report page where
// the property details, comps, and history live.
//
// The link deep-links to the exact valuation the visitor just ran
// (/home-value?avm=<user_home_id>) so the full page opens straight to this
// report rather than back at the address search. Without a home-value page in
// the agent's nav there's nowhere to link, so the caller keeps the inline
// report instead of rendering this.
export default function AccountRevealed({ flow, reportUrl }) {
  const v = flow.valuation || {};
  const hasAgentEstimate = flow.agentEstimate != null && flow.agentEstimate !== "";

  const reportHref = reportUrl
    ? (flow.userHomeId ? `${reportUrl}?avm=${encodeURIComponent(flow.userHomeId)}` : reportUrl)
    : null;

  return (
    <div className="ssc-report-estimate">
      {hasAgentEstimate ? (
        <>
          <div className="ssc-report-estimate-label">Agent estimate</div>
          <div className="ssc-report-estimate-num">{money(flow.agentEstimate)}</div>
          <div className="ssc-report-estimate-sub">
            <div className="ssc-report-estimate-label">Automated estimate</div>
            <div className="ssc-report-estimate-num">{money(v.estimate)}</div>
          </div>
        </>
      ) : (
        <>
          <div className="ssc-report-estimate-label">Estimated value</div>
          <div className="ssc-report-estimate-num">{money(v.estimate)}</div>
        </>
      )}

      {v.confidence != null && v.confidence !== "" && (
        <div className="ssc-report-confidence">
          Confidence: {typeof v.confidence === "number" ? `${v.confidence}%` : v.confidence}
        </div>
      )}

      <RangeBar low={v.low} high={v.high} estimate={v.estimate} />

      {reportHref && (
        <div className="ssc-acct-card-actions" style={{ marginTop: "1.1rem" }}>
          <a className="ss-c-btn" href={reportHref}>View full report</a>
        </div>
      )}
    </div>
  );
}
